import { MatTableDataSource } from "@angular/material";

export class Seller {
  public company: string;
  public sellerId: string;
  public teamLeaderId: string;
  public isTeamLeader: boolean;
  public isTeamLeaderPlus: boolean;
  public name: string;
  public aktiaId: string;
  public fenniaId: string;
  public folksamId: string;
  public veritasId: string;
  public team: string;
  public deleted: boolean;

  static createFromResponse(data: any): Seller {
    var seller = new Seller();
    seller.company = data["company"];
    seller.sellerId = data["sellerId"];
    seller.teamLeaderId = data["teamLeaderId"];
    seller.isTeamLeader = data["teamLeader"];
    seller.isTeamLeaderPlus = data["teamLeaderPlus"];
    seller.name = data["name"];
    seller.aktiaId = data["aktiaid"];
    seller.fenniaId = data["fenniaid"];
    seller.folksamId = data["folksamid"];
    seller.veritasId = data["veritasid"];
    seller.team = data["teamName"];
    seller.deleted = data["deleted"];
    return seller;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-sellers/Seller.ts